import { Select as SelectAntd } from 'antd';
import styled from 'styled-components';

export const StyledOption = styled.span`
  font-weight: 700;
  padding: 4px 0;
`;

export const Select: any = styled<typeof SelectAntd>(SelectAntd)`
  && > .ant-select-selector {
    border-radius: 3px;
  }
`;
